/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_LEDGER, READ_LEDGER_LIST } from 'domain/finance/ledger/useLedgerService';
import { getLedgerListUrl, getLedgerRouterPath, useLedgerRoute } from 'domain/shared/ledger';
import LedgerList from 'domain/finance/ledger/List';
import LedgerViewPage from 'domain/finance/ledger/Show';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const LedgerRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useLedgerRoute();

  return (
    <ProtectedRouter basePath={getLedgerListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_LEDGER_LIST}>
              <LedgerList />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_LEDGER}>
              <LedgerViewPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

LedgerRouter.getRouterPath = getLedgerRouterPath;

export default LedgerRouter;
